import { gql } from '@apollo/client'

const ADMISSION_SERVICE_FIELDS = gql`
  fragment AdmissionServiceFields on AdmissionServiceType {
    id
    category
    title
    isPopular
    price
    originalPrice
    feature
    paymentLink
    description
    createdAt
    updatedAt
  }
`

export const FIND_ALL_ADMISSION_SERVICES = gql`
  ${ADMISSION_SERVICE_FIELDS}
  query findAllAdmissionService($query: AdmissionServiceQueryInput!) {
    findAllAdmissionService(query: $query) {
      items {
        ...AdmissionServiceFields
      }
      count
    }
  }
`

export const UPDATE_ADMISSION_SERVICE = gql`
  ${ADMISSION_SERVICE_FIELDS}
  mutation updateAdmissionService($input: UpdateAdmissionServiceInput!) {
    updateAdmissionService(updateAdmissionServiceInputFieldName: $input) {
      ...AdmissionServiceFields
    }
  }
`
